import { configureStore } from "@reduxjs/toolkit";
import reducers from "../reducers";

const initialState = {};

export const store = configureStore({
  preloadedState: initialState,
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }) 
});